import React, {Component} from 'react';
import Spinner from 'react-spinner-material';

class CenteredSpinner extends Component {
   render() {
      return (
         <div style={{position:'relative',width:'100%',height:'100%',minHeight:200}}>
            <div style={{position:'absolute',left:'50%',top:'50%',marginLeft:-30,marginTop:-30}}>
               <Spinner width={60}
                        height={60}
                        spinnerColor={"#00bcd4"}
                        spinnerWidth={8}
                        show={true}/>
            </div>
         </div>
      )
   }
}
;

export default CenteredSpinner;



// WEBPACK FOOTER //
// ./src/components/CenteredSpinner.js